import Alpine from 'alpinejs';
import Splide from '../../Helper/NeosSplide';
import { Video } from '@splidejs/splide-extension-video';

Alpine.data('slider', () => ({
    init() {
        const splide = new Splide(this.$root, {
            breakpoints: {
                640: {
                    perPage: 1,
                },
                768: {
                    perPage: 2,
                },
            },
        });

        // Support videos and disable the play button in the backend
        splide.mount({ Video });
        const inNeosBackend = window.name === 'neos-content-main';
        splide.Components.Video.disable(inNeosBackend);
        const maxIndex = splide.length - 1;
        splide.on('autoplay:playing', (rate) => {
            // Go to the first slide after the last slide
            if (rate === 1 && maxIndex === splide.index) {
                splide.go(0);
            }
        });
    },
}));
